import React, { forwardRef } from 'react';
import { format, startOfWeek, endOfWeek } from 'date-fns';

/**
 * @typedef {object} WeeklyDatePickerInputProps
 * @property {(event: React.MouseEvent<HTMLInputElement>) => void} [onClick]
 * @property {Date} [selectedDate]
 */

/**
 * @type {React.ForwardRefExoticComponent<WeeklyDatePickerInputProps & React.RefAttributes<*>>}
 * @param {WeeklyDatePickerInputProps} props
 */
const WeeklyDatePickerInput = forwardRef((props, ref) => {
  const { selectedDate, onClick } = props;

  const customInputText = selectedDate
    ? `${format(startOfWeek(selectedDate), 'dd/MM')} - ${format(
        endOfWeek(selectedDate),
        'dd/MM yyyy'
      )}`
    : '';

  return (
    <input
      type='text'
      id='custom-date-input'
      data-testid='custom-date-input'
      value={customInputText}
      readOnly
      onClick={onClick}
      ref={ref}
    />
  );
});

WeeklyDatePickerInput.displayName = 'WeeklyDatePickerInput';

export default WeeklyDatePickerInput;
